<template>
  <span v-if="hasRole">
    <slot></slot>
  </span>
</template>
<script>
export default {
  name: 'authorization',
  props: ['printStoreRole'],
  computed: {
    hasRole() {
      return (
        this.rootStore.theme.printStore &&
        this.rootStore.user.printStore &&
        this.rootStore.user.printStore.role === this.printStoreRole
      )
    }
  }
}
</script>
